
{
  "fr": {
    "label": "modèles disponibles"
  }
}
